module.exports = __webpack_public_path__ + "img/Sachets_pour_mariage.635fbcc.jpg";